<template>
  <div class="word_cloud">
    <!-- 6. 流行的词云 -->
    <titleTem :passTitleData="passTitleData"></titleTem>

    <!-- 搜索条件 -->
    <div class="condition_search">
      <el-row>
        <!-- 选择地区 -->
        <el-col :md="24" :lg="10">
          <div class="option region">
            <div class="item_title">Select Region:</div>
            <el-select
              v-model="regionVal"
              clearable
              placeholder="Please choose"
              :popper-append-to-body="false"
              @change="changeArea"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <!-- 选择时间 -->
        <el-col :md="24" :lg="14" v-if="!isMyDate">
          <div class="option time">
            <div class="time">
              <el-row>
                <el-col :md="24" :lg="5">
                  <div class="item_title date_item">Select Time:</div>
                </el-col>
                <el-col :md="24" :lg="19">
                  <el-date-picker
                    @blur="getStartDate"
                    type="date"
                    placeholder="Start date"
                    v-model="startDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsStart"
                    size="large"
                  ></el-date-picker>
                  <span class="to_txt">&nbsp;&nbsp;to&nbsp;&nbsp;</span>
                  <el-date-picker
                    @blur="getEndDate"
                    type="date"
                    placeholder="End date"
                    v-model="endDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsEnd"
                    size="large"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :md="24" :lg="14" v-else>
          <DatePicker
            :startTime="startDate"
            :endTime="endDate"
            @startConfirm="startConfirm"
            @endConfirm="endConfirm"
            @startCancel="startCancel"
            @endCancel="endCancel"
            @startClear="startClear"
            @endClear="endClear"
          ></DatePicker>
        </el-col>
        <el-col :md="24">
          <div class="option region_det">
            <div class="item_title">Select Region:</div>
            <el-tag
              :key="tag.value"
              v-for="tag in dynamicTags"
              closable
              type="info"
              :disable-transitions="false"
              @click="getContent(tag)"
              @close="handleClose(tag)"
            >{{tag.value}}</el-tag>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="echarts_container">
      <EWordCloud :wordData="wordData" :height="height" :isNodata="isNodata"></EWordCloud>
    </div>
  </div>
</template>

<script>
import titleTem from "./Title";
import EWordCloud from "../echarts/EWordCloud";
import { wordPicture, listofCountries } from "@/common/js/http/version3Api.js";
import DatePicker from "../mobile/DatePickerLocal";
export default {
  name: "WordCloud",
  components: {
    titleTem,
    EWordCloud,
    DatePicker
  },
  data() {
    return {
      isMyDate: false,
      isNodata: false,
      pickerOptionsStart: {
        disabledDate: time => {
          if (this.endDate === "" || this.endDate !== "") {
            let endDateVal = 1561910461 * 1000;
            if (endDateVal) {
              return (
                time.getTime() < 1561910461 * 1000 ||
                time.getTime() > new Date(this.endDate).getTime()
              );
            }
          } else {
            let endDateVal = this.endDate;
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.startDate === "") {
            let beginDateVal = 1561910461 * 1000;
            if (beginDateVal) {
              return time.getTime() < 1561910461 * 1000;
            }
          } else {
            let beginDateVal = this.startDate;
            if (beginDateVal) {
              return time.getTime() < new Date(beginDateVal).getTime();
            }
          }
        }
      },
      passTitleData: {
        titleName: "Hot-word Cloud",
        commentTxt:
          "It shows hot content of the brand posted by the foreign media in different regions within a certain time frame (in past 30 days by default)."
      },
      height: "350px",
      wordData: [],

      // 搜索条件
      regionVal: "",
      startDate: "",
      endDate: "",
      dynamicTags: [],
      options: [],
      clickTruetag: [],
      countryArray: [],
      clickState: false
    };
  },

  created() {
    //屏幕宽度
    if (document.documentElement.clientWidth < 768) this.isMyDate = true;
    else this.isMyDate = false;
    this.setDate();
  },

  mounted() {
    this.getlistofCountry();
    this.getWord();
  },
  methods: {
    setDate() {
      this.startDate = this.$moment(new Date())
        .subtract(90, "days")
        .format("YYYY-MM-DD");
      this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    },

    getStartDate() {
      this.getWord();
    },
    getEndDate() {
      this.getWord();
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.clickTruetag.splice(this.clickTruetag.indexOf(tag.value), 1);
      this.options.filter(item => {
        if (item.value === tag.value) {
          item.disabled = false;
        }
      });
      this.regionVal = "";

      this.getWord();
    },
    getContent(val) {
      this.getWord();
    },
    //获取国家列表
    getlistofCountry() {
      let data = {
        companyId: this.$route.query.id,
        brandToken: localStorage.getItem("brand-token")
      };

      listofCountries(data).then(res => {
        this.options = res.result;

        this.options.map(item => {
          item.disabled = false;
          return item;
        });
      });
    },
    getWord() {
      if (this.startDate == null || this.startDate == 'Invalid date') {
        this.startDate = "";
      }
      if (this.endDate == null || this.endDate == 'Invalid date') {
        this.endDate = "";
      }
      let data = {
        companyId: this.$route.query.id,
        regionalNames: this.clickTruetag,
        startTime: this.startDate,
        endTime: this.endDate,
        brandToken: localStorage.getItem("brand-token")
      };
      wordPicture(data).then(res => {
        this.wordData = res.result.series[0].data;
        if (this.wordData.length === 0) {
          this.isNodata = true;
        } else {
          this.isNodata = false;
        }
      });
    },
    //选择国家
    changeArea(val) {
      this.clickState = true;
      this.options.filter(item => {
        if (item.value === this.regionVal) {
          item.disabled = true;
        }
      });
      if (this.clickState === true && this.regionVal !== "") {
        this.countryArray.push({ value: this.regionVal });
        for (var i = 0; i < this.countryArray.length; i++) {
          for (var j = i + 1; j < this.countryArray.length; j++) {
            if (this.countryArray[i].value == this.countryArray[j].value) {
              this.countryArray.splice(j, 1);
              j--;
            }
          }
        }
        this.dynamicTags = this.countryArray;
        this.clickTruetag.push(val);
      }
      this.getWord();
    },
    //移动端日期选择
    startConfirm(startTime) {
      this.startDate = this.$moment(new Date(startTime)).format("YYYY-MM-DD");
      this.getWord();
    },
    endConfirm(endTime) {
      this.endDate = this.$moment(new Date(endTime)).format("YYYY-MM-DD");
      this.getWord();
    },
    startCancel() {
      this.startDate = "";
      this.getWord();
    },
    endCancel() {
      this.endDate = "";
      this.getWord();
    },
    startClear() {
      this.startDate = "";
      this.getWord();
    },
    endClear() {
      this.endDate = "";
      this.getWord();
    }
  },
  watch: {
    startDate(newValue) {
      if (newValue == null) {
        this.getWord();
      }
    },
    endDate(newValue) {
      if (newValue == null) {
        this.getWord();
      }
    }
  }
};
</script>

<style scoped>
.time >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 125px !important;
}
.time >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.time .date_item {
  margin-right: 0 !important;
  line-height: 32px !important;
  width: 90% !important;
  text-align: right !important;
}
@media screen and (max-width: 1024px) {
  .time .date_item {
    text-align: left !important;
  }
}
</style>